import {
  GET_CUSTOMER_GROUP,
  GET_CUSTOMER_GROUP_SUCCESS,
  GET_CUSTOMER_GROUP_FAIL,
  DELETE_CUSTOMER_GROUP,
  DELETE_CUSTOMER_GROUP_SUCCESS,
  DELETE_CUSTOMER_GROUP_FAIL,
  UPDATE_CUSTOMER_GROUP,
  UPDATE_CUSTOMER_GROUP_SUCCESS,
  UPDATE_CUSTOMER_GROUP_FAIL,
  ADD_NEW_CUSTOMER_GROUP,
  ADD_CUSTOMER_GROUP_SUCCESS,
  ADD_CUSTOMER_GROUP_FAIL,
  CUSTOMER_GROUP_LOADING,
  CUSTOMER_GROUP_RESET,
  CUSTOMER_GROUP_RESET_CREATE
} from "./actionType";

export const resetCustomerGroupState = (actionType) => ({
  type: CUSTOMER_GROUP_RESET,
  payload: { actionType },
});


export const resetCustomerGroupCreateState = (actionType) => ({
  type: CUSTOMER_GROUP_RESET_CREATE,
  payload: { actionType }
});

export const getCustomerGroupSuccess = (actionType, data) => ({
  type: GET_CUSTOMER_GROUP_SUCCESS,
  payload: { actionType, data },
});

export const getCustomerGroupFail = (actionType, error) => ({
  type: GET_CUSTOMER_GROUP_FAIL,
  payload: { actionType, error },
});

export const getCustomerGroup = data => ({
  type: GET_CUSTOMER_GROUP,
  payload: data,
});

export const getCustomerGroupLoading = () => ({
  type: CUSTOMER_GROUP_LOADING
});

export const deleteCustomerGroup = data => ({
  type: DELETE_CUSTOMER_GROUP,
  payload: data,
});

export const deleteCustomerGroupSuccess = data => ({
  type: DELETE_CUSTOMER_GROUP_SUCCESS,
  payload: data,
});

export const deleteCustomerGroupFail = error => ({
  type: DELETE_CUSTOMER_GROUP_FAIL,
  payload: error,
});

export const updateCustomerGroup = data => ({
  type: UPDATE_CUSTOMER_GROUP,
  payload: data,
});

export const updateCustomerGroupFail = error => ({
  type: UPDATE_CUSTOMER_GROUP_FAIL,
  payload: error,
});

export const updateCustomerGroupSuccess = data => ({
  type: UPDATE_CUSTOMER_GROUP_SUCCESS,
  payload: data,
});

export const addNewCustomerGroup = data => ({
  type: ADD_NEW_CUSTOMER_GROUP,
  payload: data,
});

export const addCustomerGroupSuccess = data => ({
  type: ADD_CUSTOMER_GROUP_SUCCESS,
  payload: data,
});

export const addCustomerGroupFail = error => ({
  type: ADD_CUSTOMER_GROUP_FAIL,
  payload: error,
});